import { render, staticRenderFns } from "./KecamatanContent.vue?vue&type=template&id=87afa990&scoped=true"
import script from "./KecamatanContent.vue?vue&type=script&lang=js"
export * from "./KecamatanContent.vue?vue&type=script&lang=js"
import style0 from "./KecamatanContent.vue?vue&type=style&index=0&id=87afa990&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87afa990",
  null
  
)

export default component.exports